// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/hard-drive.js';

import { paths } from '../generated/hard-drive';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('hard-drive', Original, paths);
